<div class="container"
     fxLayout="column"
     fxLayoutAlign.gt-md="center center"
     fxLayoutGap="10px">

      <span fxFlex>Stai per essere rediretto alla pagina del servizio richiesto..</span>

</div>
